import './Text.css';

export function ShopDonate() {
  return (
    <div class="body">
        <p>Coming Soon</p>
    </div>

  );
}
